import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Spinner } from "./spinner";

const FADE_MS = 260;

const removeBootOverlay = () => {
  const boot = document.getElementById("till-boot-overlay");
  if (boot && boot.parentNode) boot.parentNode.removeChild(boot);
};

export const TillSettlingOverlay = ({ show, message }) => {
  const [rendered, setRendered] = useState(show === true);

  useEffect(() => {
    if (show) {
      setRendered(true);
      removeBootOverlay();
      return undefined;
    }
    const timer = setTimeout(() => setRendered(false), FADE_MS);
    return () => clearTimeout(timer);
  }, [show]);

  if (!rendered) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 100000,
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        padding: "24px",
        textAlign: "center",
        opacity: show ? 1 : 0,
        transition: `opacity ${FADE_MS}ms ease`,
        pointerEvents: show ? "auto" : "none",
      }}
    >
      <Spinner size={56} />
      <p style={{ margin: 0, fontSize: "17px", fontWeight: 600, color: "#333" }}>{message}</p>
      <p style={{ margin: 0, fontSize: "13px", color: "#666" }}>Please do not refresh or close this window.</p>
    </div>,
    document.body,
  );
};
